import React from "react";
import { DatePicker, InputText } from "../../components";
import { useFormContext } from "react-hook-form";

function PurchaseDetails() {
  const { control } = useFormContext();
  return (
    <>
      <div className="mb-8 space-y-3">
        <InputText
          label="Name on the invoice"
          control={control}
          required
          name="purchase_info.name_on_invoice"
        />
        <InputText
          label="Invoice number"
          control={control}
          required
          name="purchase_info.invoice_number"
        />
        <DatePicker
          label="Date of Purchase"
          control={control}
          required
          name="purchase_info.date_of_purchase"
          placeholder="Date of Purchase"
          disableFuture
        />
      </div>
    </>
  );
}

export default PurchaseDetails;
